import React from "react";
import {
    Bar,
    BarChart, CartesianGrid,
    Legend,
    ResponsiveContainer,
    Tooltip, XAxis, YAxis
} from "recharts";

interface MonthLeaveTrendChartProps {
    summary: any;
}

const MonthLeaveTrendChart = ({summary}: MonthLeaveTrendChartProps) => {
    const LEAVE_COLORS: Record<string, string> = {
        GENERAL_LEAVE: "#10b981",
        SICK_LEAVE: "#f59e0b",
        CASUAL_LEAVE: "#749dff",
        PATERNITY_LEAVE: "#ef4444",
        MATERNITY_LEAVE: "#4f46e5",
        BEREAVEMENT_LEAVE: "#8b5cf6",
    };

    const leaveTypes =
        summary?.length > 0
            ? Object.keys(summary[0]).filter(key => key !== "month")
            : [];

    return (
        <section className="pn-asset__card">
            <div className="pn-asset__card__header">
                <div>
                    <h3 className="pn-asset__card__title"> Monthly Leave Analysis </h3>
                </div>
            </div>

            <div className="pn-asset__chart-area">
                <ResponsiveContainer width="100%" height={195}>
                    <BarChart
                        data={summary}
                        margin={{top: 8, right: 8, left: -40, bottom: 0}}
                        barSize={24}
                        barGap={1}
                    >
                        <CartesianGrid strokeDasharray="3 3" stroke="#F3F4F6" vertical={false}/>
                        <XAxis
                            dataKey="month"
                            tick={{fontSize: 11, fill: '#9CA3AF', fontFamily: 'DM Sans, sans-serif'}}
                            axisLine={false}
                            tickLine={false}
                        />
                        <YAxis
                            allowDecimals={false}
                            tick={{fontSize: 11, fill: '#9CA3AF', fontFamily: 'DM Sans, sans-serif'}}
                            axisLine={false}
                            tickLine={false}
                        />
                        <Tooltip cursor={{fill: 'rgba(37,99,235,0.04)'}}/>
                        <Legend
                            wrapperStyle={{fontSize: 11, fontFamily: 'DM Sans, sans-serif', paddingTop: 12}}
                            iconType="circle"
                            iconSize={8}
                        />
                        {leaveTypes.map(type => (
                            <Bar
                                key={type}
                                dataKey={type}
                                fill={LEAVE_COLORS[type]}
                                radius={[4, 4, 0, 0]}
                            />
                        ))}
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </section>
    );
};

export default MonthLeaveTrendChart;